import React, { useEffect } from "react";
import { useTranslation } from "lib/i18n/use-translation";

const NotFound = () => {
  const { t } = useTranslation(["common"]);

  useEffect(() => {
    document.title = `Page Not Found - Walking on Earth`;
  }, []);

  return (
    <div className="corporate-container">
      <h2>{t("common:error.notFound")}</h2>
    </div>
  );
};

export default NotFound;
